import Routes from './routes'

export {
  Routes
}



/** WEBPACK FOOTER **
 ** ./pub/client/routes/index.js
 **/